exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3-5b-5 .simplest__structure-framework__bottom-box-points{margin:20px 0;display:block}#diagram3-5b-5 .simplest__structure-framework__bottom-box-points p{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:16px;line-height:18px}#diagram3-5b-5 .simplest__structure-framework__bottom-box-points p:last-child{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5b/diagram3/diagram3.scss
// module id = 1398
// module chunks = 0